module.exports = __webpack_public_path__ + "static/Grafika8-8184221ce8e2735aad96dfdc257ddc29.png";